Ext.define('SA.view.ImportWindow', {
    alias: 'widget.import-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-import-window',
    floating: true,
    modal: true,

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-import-window-header',
            itemId: 'header',

            items: [
                {
                    xtype: 'import-step-indicator',
                    itemId: 'stepIndicator'
                }, {
                    xtype: 'close-button',
                    closeAction: 'onCancelClick'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-import-window-body',
            itemId: 'body'
        }, {
            xtype: 'simple-container',
            cls: 'sa-import-window-footer',
            itemId: 'footer',

            items: [
                {
                    xtype: 'sa-button',
                    cls: 'sa-import-window-back-btn',
                    hidden: true,
                    itemId: 'backBtn',
                    text: 'Back',
                    width: 65
                }, {
                    xtype: 'sa-button',
                    itemId: 'nextBtn',
                    text: 'Next',
                    ui: 'primary',
                    width: 85
                }, {
                    xtype: 'sa-button',
                    hidden: true,
                    itemId: 'beginImportBtn',
                    text: 'Begin Import',
                    ui: 'primary',
                    width: 115
                }, {
                    xtype: 'sa-button',
                    cls: 'sa-import-window-cancel-btn',
                    itemId: 'cancelBtn',
                    text: 'Cancel'
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.stepIndicator = this.down('#stepIndicator');

        this.header = this.down('#header');
        this.footer = this.down('#footer');

        this.backBtn = this.down('#backBtn');
        this.nextBtn = this.down('#nextBtn');
        this.beginImportBtn = this.down('#beginImportBtn');
        this.cancelBtn = this.down('#cancelBtn');

        this.down('#body').add(this.stepViews);
    },

    beforeDestroy() {
        this.mun(SA.Viewport, 'resize', this.onViewportResize, this);

        this.callParent();
    },

    ensureWindowBottomNotBelowViewport() {
        var lowestBottom = Ext.Element.getViewportHeight() - 10,
            {bottom: currentBottom} = this.getBox(),
            overflow = Math.max(currentBottom - lowestBottom, 0);

        this.move('up', overflow);
    },

    getVisibleStep() {
        return this.stepViews.find(step => step.isVisible());
    },

    initEvents() {
        this.callParent();

        this.nextBtn.on('click', this.onNextClick, this);
        this.backBtn.on('click', this.onBackClick, this);
        this.beginImportBtn.on('click', this.onBeginImportClick, this);
        this.cancelBtn.on('click', this.onCancelClick, this);

        this.mon(SA.Viewport, 'resize', this.onViewportResize, this);
    },

    onBackClick() {
        this.fireEvent('click:back');
    },

    onBeginImportClick() {
        this.fireEvent('click:beginImport');
    },

    onCancelClick() {
        this.fireEvent('click:cancel');
    },

    onNextClick() {
        this.fireEvent('click:next');
    },

    onViewportResize() {
        this.refreshSize();
        this.center();
    },

    refreshButtonVisibility(index) {
        var lastIndex = this.stepViews.length - 1,
            hasPreviousStep = index > 0,
            hasNextStep = index < lastIndex;

        this.backBtn.setVisible(hasPreviousStep);
        this.nextBtn.setVisible(hasNextStep);
        this.beginImportBtn.setVisible(!hasNextStep);
    },

    refreshSize() {
        var step = this.getVisibleStep(),
            widthExcludingStep = 2, 
            heightExcludingStep = 2 + this.header.getHeight() + this.footer.getHeight(),
            maxStepWidth = Ext.Element.getViewportWidth() - widthExcludingStep - 20, 
            maxStepHeight = Ext.Element.getViewportHeight() - heightExcludingStep - 20;

        step.resizeWithConstraint({maxWidth: maxStepWidth, maxHeight: maxStepHeight});

        this.setSize({
            width: step.getWidth() + widthExcludingStep,
            height: step.getHeight() + heightExcludingStep
        });
    },

    refreshStepIndicator(index) {
        this.stepIndicator.setActiveStepIndex(index);
    },

    showStepAtIndex(index) {
        this.getVisibleStep().hide();
        this.stepViews[index].show();

        this.refreshStepIndicator(index);
        this.refreshButtonVisibility(index);
        this.refreshSize();

        this.center();
    }
});